import React, { useState, useEffect, useContext } from "react";
import Paper from "@mui/material/Paper";
import { Template, TemplatePlaceholder } from "@devexpress/dx-react-core";
import {
  Grid,
  Table,
  TableHeaderRow,
  TableFilterRow,
  PagingPanel,
  TableColumnResizing,
  Toolbar,
  TableColumnVisibility,
  ColumnChooser,
} from "@devexpress/dx-react-grid-material-ui";

import {
  IntegratedFiltering,
  FilteringState,
  SortingState,
  PagingState,
  IntegratedPaging,
  IntegratedSorting,
} from "@devexpress/dx-react-grid";
import { getWebhooks, getWebhook } from "../../services/RepositoryService";
import Spinner from "../../components/Spinner";
import StarekContext from "../../context/StarekContext";
import { useNavigate } from "react-router-dom";

const TableCell = (props) => {
  const { row, column } = props;
  const navigator = useNavigate();
  if (column.name === "name") {
    return (
      <Table.Cell
        {...props}
        onClick={() => {
          navigator(`/webhooks/${row.id}`);
        }}
      >
        <a href='#'>{row.name}</a>
      </Table.Cell>
    );
  }
  return <Table.Cell {...props} />;
};

const Webhooks = () => {
  const context = useContext(StarekContext);
  const navigator = useNavigate();
  const [items, setItems] = useState();
  const [selected, setSelected] = useState();
  const [item, setItem] = useState([]);
  const [loadingPrimary, setLoadingPrimary] = useState(true);
  const [loading, setLoading] = useState(true);
  const [isAdding, setIsAdding] = useState(false);
  const [columns, setColumns] = useState([
    { name: "name", title: "Name" },
    { name: "description", title: "Description" },
    { name: "event", title: "Event" },
    { name: "method", title: "Method" },
    { name: "url", title: "URL" },
  ]);

  const [pageSizes] = useState([5, 10, 20]);
  const [defaultColumnWidths] = useState([
    { columnName: "name", width: 200 },
    { columnName: "description", width: 250 },
    { columnName: "event", width: 150 },
    { columnName: "method", width: 150 },
    { columnName: "url", width: 250 },
  ]);
  const [defaultHiddenColumnNames] = useState([{ columnName: "name" }]);
  const [tableColumnExtensions] = useState([]);
  const [showFilter] = useState(false);
  const hiddenColumns = [{ columnName: "name" }];

  useEffect(() => {
    (async () => {
      try {
        const webhooks = await getWebhooks();
        console.log("webhooks => ", webhooks);
        setItems(webhooks);
      } catch (error) {
        context.showErrorMessage(error.message);
      }
      setLoadingPrimary(false);
    })();
  }, []);

  useEffect(() => {
    if (!selected || selected.length == 0 || selected.length > 1) return;
    (async () => {
      const webhook = await getWebhook(selected[0]);
      setItem(webhook);
      setIsAdding(true);
      setLoading(false);
    })();
  }, [selected]);

  return loadingPrimary ? (
    <>
      <Spinner />
      <div className='text-xs d-flex justify-content-center'>
        <i className='fa fa-bullhorn fa-10x'></i>
      </div>
    </>
  ) : (
    <div>
      {items && (
        <div>
          <br />
          <br />
          <Paper>
            <Grid rows={items} columns={columns} getRowId={(row) => row.id}>
              {showFilter && <FilteringState />}
              <SortingState />
              <PagingState
                defaultCurrentPage={0}
                defaultPageSize={pageSizes[1]}
              />
              {showFilter && <IntegratedFiltering />}
              <IntegratedSorting />
              <IntegratedPaging />
              <Table
                columnExtensions={tableColumnExtensions}
                cellComponent={TableCell}
              />
              <TableColumnVisibility
                defaultHiddenColumnNames={defaultHiddenColumnNames}
              />
              <TableColumnResizing defaultColumnWidths={defaultColumnWidths} />
              <TableHeaderRow showSortingControls />
              {showFilter && <TableFilterRow />}
              <Toolbar />
              <Template name='toolbarContent'>
                <TemplatePlaceholder />
                <div
                  className='btn btn-primary'
                  onClick={() => {
                    navigator(`/webhooks/0`);
                  }}
                >
                  Add Webhook
                </div>
              </Template>
              <ColumnChooser hiddenColumnNames={hiddenColumns} />
              <PagingPanel pageSizes={pageSizes} />
            </Grid>
          </Paper>
        </div>
      )}
    </div>
  );
};

export { Webhooks };
